/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
/*
 * @category  Puma
 * @author    Beshoy Samuel <beshoy.samuel@scandiweb.com>
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 * @copyright Copyright (c) 2024 Scandiweb, Inc (https://scandiweb.com)
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { STYLEGUIDE_POPUP } from 'Route/StyleGuide/StyleGuide.config';
import { setForceShowPopup, toggleOverlayByKey } from 'Store/Overlay/Overlay.action';
import { showPopup } from 'Store/Popup/Popup.action';

import StickySubscribeButtonComponent from './StickySubscribeButton.component';

/** @namespace Scandipwa/Component/StickySubscribeButton/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    activeOverlay: state.OverlayReducer.activeOverlay,
    stickySubscribeText: state.ConfigReducer.sticky_subscribe_text,
    isSignedIn: state.MyAccountReducer.isSignedIn
});

/** @namespace Scandipwa/Component/StickySubscribeButton/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    showPopup: () => dispatch(showPopup('title')),
    showOverlay: (key) => dispatch(toggleOverlayByKey(key)),
    setForceShowPopup: (val) => dispatch(setForceShowPopup(val))
});

/** @namespace Scandipwa/Component/StickySubscribeButton/Container */
export class StickySubscribeButtonContainer extends PureComponent {
    static propTypes = {
        activeOverlay: PropTypes.string.isRequired,
        stickySubscribeText: PropTypes.string.isRequired,
        showPopup: PropTypes.func.isRequired,
        showOverlay: PropTypes.func.isRequired,
        setForceShowPopup: PropTypes.func.isRequired,
        isSignedIn: PropTypes.bool.isRequired
    };

    state = {
        isManuallyClosed: false
    };

    containerFunctions = {
        setIsManuallyClosed: this.setIsManuallyClosed.bind(this),
        showSubscriptionOverlay: this.showSubscriptionOverlay.bind(this)
    };

    containerProps() {
        const { activeOverlay, stickySubscribeText, isSignedIn } = this.props;
        const { isManuallyClosed } = this.state;

        return {
            activeOverlay,
            stickySubscribeText,
            isManuallyClosed,
            isSignedIn
        };
    }

    setIsManuallyClosed(e) {
        e.stopPropagation();

        this.setState({ isManuallyClosed: true });
    }

    showSubscriptionOverlay(e) {
        const { showPopup, showOverlay, setForceShowPopup } = this.props;

        e.stopPropagation();
        setForceShowPopup(true);
        showPopup();
        showOverlay(STYLEGUIDE_POPUP);
    }

    render() {
        return (
            <StickySubscribeButtonComponent
              { ...this.containerProps() }
              { ...this.containerFunctions }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StickySubscribeButtonContainer);
